/**
 * @summary get listing category from parentId prefix
 */
export default (function (parentId) {
  if (parentId === void 0) {
    parentId = '';
  }
  let category = 'listing';
  if (parentId.includes('alpm-dlr')) {
    category = 'alpham-dealer';
  } else if (parentId.includes('alpm')) {
    category = 'alpham';
  } else if (parentId.includes('alp-dlr')) {
    category = 'alpha-dealer';
  } else if (parentId.includes('alp')) {
    category = 'alpha';
  } else if (parentId.includes('spv_lstg_')) {
    category = 'spotlight';
  } else if (parentId.includes('sup_v_lstg_')) {
    category = 'supplemental';
  } else if (parentId.includes('dl_v_lstg')) {
    category = 'elot';
  } else if (parentId.includes('rv_lstg_')) {
    category = 'recommendations';
  } else if (parentId.includes('comp_lstg')) {
    category = 'compare';
  } else if (parentId.includes('dhs_v_lstg')) {
    category = 'dhs';
  } else if (parentId.includes('rv_lstg')) {
    category = 'recommendations';
  } else if (parentId.includes('sim_v_lstg') || parentId.includes('similar')) {
    category = 'similar';
  } else if (parentId.includes('sim')) {
    category = 'sim';
  } else if (parentId.includes('markt_lnd')) {
    category = 'elot';
  } else if (parentId.includes('ncb')) {
    category = 'ncb';
  } else if (parentId.includes('ime')) {
    category = 'ime';
  } else if (['interested', 'reduced'].includes(parentId)) {
    category = parentId;
  }
  return category;
});